import * as Website from '../Config/Website.js';

const ScrollBox = () => {
  const targetElms = document.getElementsByClassName('js-scrollBox');
  if (targetElms.length === 0) return;

  for(const targetElm of targetElms) {
    if(targetElm.clientWidth < targetElm.scrollWidth) {
      targetElm.classList.remove(Website.classList.inact);
    } else {
      targetElm.classList.add(Website.classList.inact);
      targetElm.classList.remove(Website.classList.actView);
    }
    if(targetElm.getBoundingClientRect().top < Website.status.winHeight / 5) {
      targetElm.classList.add(Website.classList.actView);
    }
    targetElm.addEventListener('scroll', () => {
      targetElm.classList.add(Website.classList.actView);
    });
  }
}

export default ScrollBox;